function playVideo(e){
  let clip = document.querySelector(`.clip[data-video="${ e.dataset.video }"]`);
  let close = clip.querySelector('.close');
  let video = clip.querySelector('video');
  e.classList.add('active');
  clip.classList.add('active');
  video.play();
  video.currentTime = 0;
}
function closeVideo(e){
  let clip = e.parentElement;
  let video = e.parentElement.querySelector('video');
  let btn = document.querySelector(`.play-button[data-video="${ clip.dataset.video }"]`);
  btn.classList.remove('active');
  clip.classList.remove('active');
  video.pause();
}